import React from 'react';
import { Navbar, Button } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import PropTypes from 'prop-types';
import { DropdownButton } from 'react-bootstrap';
import { MenuItem } from 'react-bootstrap';
import './NavBar.css';


class NavBar extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (e) => {
        const { setScene } = this.props;
        setScene(e[0]);
    }

    linkClick = (pageName) => {
        const { setPage } = this.props;
        setPage(pageName);
    }

    render() {
        const { options, setScene, showCreateActivityModal, showCreateSkillModal, showCreateSkillGroupModal } = this.props;
        return (
            <Navbar className="navbar navbar-inverse navbar-fixed-top">
                <div className="container">
                    <div className="navbar-header">
                        <a className="navbar-brand" onClick={() => this.linkClick("")}>
                            <i className="fas fa-link"></i>&nbsp; Hoover
                        </a>
                    </div>
                    <div id="navbar" className="navbar-collapse collapse">
                        <form name='activitySearch' className="navbar-form navbar-left" onSubmit={e => {
                            e.preventDefault();
                            setScene(document.querySelector('input.rbt-input-main').value);
                        }}>
                            <div className="input-group">
                                <Typeahead
                                    className="scene-load-input"
                                    options={options}
                                    placeholder={'Activity name...'}
                                    submitFormOnEnter={true}
                                    onChange={this.handleChange}
                                />
                                <span className="input-group-btn">
                                    <Button className="scene-load-button" type='submit'>
                                        <i className="fas fa-search"></i>
                                    </Button>
                                </span>
                            </div>
                        </form>
                        <ul className="nav navbar-nav navbar-left header-links">
                            <li>
                                <a onClick={() => this.linkClick("allActivities")}>Activities</a>
                            </li>
                            <li>
                                <a onClick={() => this.linkClick("allSkills")}>Skills</a>
                            </li>
                            <li>
                                <a onClick={() => this.linkClick("mediaSearch")}>Media Search</a>
                            </li>
                        </ul>
                        <ul className="nav navbar-nav navbar-right">
                            <li>
                                <DropdownButton
                                    bsStyle='default'
                                    title={
                                        <div style={{ display: 'inline-block' }}>
                                            <i className="fas fa-plus"></i>
                                        </div>
                                    }
                                    key='addMenu1'
                                    id='addMenu-dropdown1'
                                >
                                    <MenuItem eventKey="1" onClick={() => showCreateActivityModal()}>
                                        <i className="fas fa-plus-square"></i>&nbsp; New Activity
                                    </MenuItem>
                                    <MenuItem eventKey="2" onClick={() => showCreateSkillModal()}>
                                        <i className="fas fa-plus-circle"></i>&nbsp; New Skill
                                    </MenuItem>
                                    <MenuItem eventKey="3" onClick={() => showCreateSkillGroupModal()}>
                                        <i className="fas fa-plus-circle"></i>&nbsp; New Skill Group
                                    </MenuItem>
                                </DropdownButton>
                            </li>
                        </ul>
                    </div>
                </div>
            </Navbar>
        );
    }
}

NavBar.propTypes = {
    options: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    setScene: PropTypes.func.isRequired,
    showCreateActivityModal: PropTypes.func.isRequired,
    showCreateSkillModal: PropTypes.func.isRequired,
    showCreateSkillGroupModal: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/navBar/NavBar.js